export default __webpack_public_path__ + "static/media/Gallery12.01933c8a.jpg";